export default __webpack_public_path__ + "static/media/search.81d87e07.svg";